import React, { useEffect, useRef, useState } from "react";
import {
  MAIN_URL,
  getApiCall,
  getApiCallForVideo,
  postApiCall,
  postFormApiCall,
} from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
import {
  CircleSpinnerOverlay,
  FerrisWheelSpinner,
} from "react-spinner-overlay";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ReadingMaterials = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [readingID, setReadingID] = useState("");

  const [loading, setLoading] = useState(false);

  const [classList, setClassList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [className, setClassName] = useState("");
  const [moduleName, setModuleName] = useState("");
  //   const [levelList, setLevelList] = useState([]);
  //   const [levelName, setLevelName] = useState("");

  const [videoTitle, setVideoTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [fileEnglish, setFileEnglish] = useState(null);
  const [fileHindi, setFileHindi] = useState(null);
  const [priority, setPriority] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);

    const res = await getApiCall("readings/get-all");
    setData(res.data);

    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageFile(event.target.files[0]);
    } else {
      alert("Something went wrong");
    }
  };
  const handleFileUploadEn = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileEnglish(file);
    } else {
      alert("Something went wrong");
    }
  };
  const handleFileUploadHi = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileHindi(event.target.files[0]);
    } else {
      alert("Something went wrong");
    }
  };

  const imageFileInputRef = useRef(null);
  const fileInputRefEnglish = useRef(null);
  const fileInputRefHindi = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("id", readingID);
    formData.append("class_id", className);
    formData.append("module_id", moduleName);
    formData.append("topic", videoTitle);
    formData.append("fileEnglish", fileEnglish);
    formData.append("fileHindi", fileHindi);
    // formData.append("level_id", levelName);
    formData.append("thumbnail_path", imageFile);
    formData.append("priority", priority);

    let res = {};
    if (readingID === "") {
      res = await postFormApiCall("readings/add", formData);
    } else {
      res = await postFormApiCall("readings/update", formData);
    }
    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    setReadingID("");

    if (imageFileInputRef.current) {
      imageFileInputRef.current.value = "";
    }
    if (fileInputRefEnglish.current) {
      fileInputRefEnglish.current.value = "";
    }
    if (fileInputRefHindi.current) {
      fileInputRefHindi.current.value = "";
    }

    setVideoTitle("");
    setModuleName("");
    setClassName("");
    setPriority("");
    // setModuleList([]);
    // setLevelList([]);

    setImageFile(null);
    setLoading(false);
    fetchData();
  };

  const onClassChange = async (val) => {
    setLoading(true);
    const boardRes = await postApiCall("module/get-by-class", { id: val });
    setModuleList(boardRes.data);
    setLoading(false);
  };

  // const onModuleChange = async (val) => {
  //   setLoading(true);
  //   const leveRes = await postApiCall("levels/get-by-module", { id: val });
  //   setLevelList(leveRes.data);
  //   setLoading(false);
  // };

  const columns = [
    {
      title: "Sl. no",
      field: "serial",
      cellStyle: {
        width: "5%",
      },
    },
    {
      title: "Image",
      field: "thumbnail_path",
      cellStyle: {
        width: "20%",
      },
      render: (rowData) => {
        return (
          <>
            <img
              src={rowData.thumbnail_path}
              height={70}
              width={70}
              alt="thumbnail"
            />
          </>
        );
      },
    },
    {
      title: "Title",
      field: "topic",
    },
    { title: "Module", field: "module_name" },
    {
      title: "Class",
      field: "class_name",
      cellStyle: {
        width: "5%",
      },
    },
    // { title: "Level", field: "level_name" },
    {
      title: "Files",
      field: "file",
      render: (rowData) => {
        return (
          <>
            {rowData.readings_url_en && (
              <a
                href={rowData.readings_url_en}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "10px" }}
              >
                📄 View (EN)
              </a>
            )}
            <br />
            {rowData.readings_url_hi && (
              <a
                href={rowData.readings_url_hi}
                target="_blank"
                rel="noopener noreferrer"
              >
                📄 View (HI)
              </a>
            )}
          </>
        );
      },
    },
  ];

  const handleEdit = async (rowData) => {
    setReadingID(rowData.id);

    setClassName(rowData.grade_id);
    onClassChange(rowData.grade_id);
    setModuleName(rowData.module_id);
    setPriority(rowData.priority);
    // onModuleChange(rowData.module_id);
    // if (rowData.level_id != null) setLevelName(rowData.level_id);

    setVideoTitle(rowData.topic);

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  const handleDelete = async (rowData) => {
    new Swal({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("readings/delete", { id: rowData.id });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Reading Materials</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Reading Materials</li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {readingID === "" ? "Add" : "Edit"} Reading Materials
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {readingID === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                                onClassChange(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {readingID === "" ? "Select" : "Edit"} Module
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setModuleName(e.target.value);
                                // onModuleChange(e.target.value);
                              }}
                              required
                              value={moduleName}
                              name="module_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {moduleList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.module_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {readingID === "" ? "Select" : "Edit"} Priority
                            </label>
                            <select
                              className="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => setPriority(e.target.value)}
                              required
                              value={priority}
                              name="priority"
                            >
                              <option value="" disabled>
                                Select an option
                              </option>
                              {Array.from({ length: 20 }, (_, i) => i + 1).map(
                                (num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        {/* <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {readingID === "" ? "Select" : "Edit"} Select
                              Level
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setLevelName(e.target.value);
                              }}
                              required
                              value={levelName}
                              name="level_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {levelList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div> */}

                        <div className="col-md-12 col-sm-12">
                          <h5>Add Information</h5>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {readingID === "" ? "Add" : "Edit"} Topic
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setVideoTitle(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={videoTitle}
                              name="title"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12"></div>

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              {readingID === "" ? "Add" : "Edit"} File (in
                              english)
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                // accept="image/*"
                                ref={fileInputRefEnglish}
                                onChange={(e) => handleFileUploadEn(e)}
                                // required={readingID === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              {readingID === "" ? "Add" : "Edit"} File (in
                              hindi)
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                // accept="image/*"
                                ref={fileInputRefHindi}
                                onChange={(e) => handleFileUploadHi(e)}
                                // required={readingID === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              {readingID === "" ? "Add" : "Edit"} Thumbnail
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                accept="image/*"
                                ref={imageFileInputRef}
                                onChange={(e) => handleThumbnailChange(e)}
                                // required={readingID === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        {readingID === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Reading Materials"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute(
                            "download",
                            "reading-materials.csv"
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("reading-materials.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        (rowData) => ({
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Delete />
                            </span>
                          ),
                          tooltip: "Delete",
                          onClick: (event, rowData) => handleDelete(rowData),
                        }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default ReadingMaterials;
